import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Grip } from "../../../../Icons/icons";

export const TopicSortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="flex w-full gap-2 space-x-2">
      <div
        className="text-xs h-8 w-2 flex items-center justify-center cursor-move"
        {...attributes}
        {...listeners}
      >
        <Grip />
      </div>
      {children}
    </div>
  );
};
